import ajaxUtils from "./ajaxutils";
import wsUtils from "./wsUtils";
import utils from "./utils";
import shelltool from "./shelltool";

const public_path = "https://static.h5bqb.top/static/images/";
const file_icon = `${public_path}file_icon.svg`;
const pic_uploading = `${public_path}pic_uploading.png`;
const video_bg = `${public_path}video_bg.png`;
const READ_DWELL_MS = 500;
const READ_VISIBLE_RATIO = 0.6;
const READ_LAYOUT_CHECK_DELAY = 160;
const READ_RECEIPT_QUEUE_STORAGE_PREFIX = "zhini_read_receipt_queue_";

const readReceiptState = {
  initialized: false,
  pageVisible: true,
  pageFocused: true,
  pendingReadMid: "",
  pendingSeenMids: [],
  pendingTimerId: null,
  layoutCheckTimerId: null,
  resizeObserver: null,
  mutationObserver: null,
  seenIncomingMids: {},
  lastReportedReadMid: "",
  queuedReadMid: "",
  isFlushing: false,
  showNewMessageHint: false,
  messageContents: {},
};

window.addEventListener("offline", (e) => {
  const sysMsg = {
    msgtype: "system",
    content: "网络连接已断开，请检查网络！",
    mid: "native_" + new Date().getTime(),
  };
  showMoreMessage(sysMsg, true);
});

const getReadableMsgTime = (msgTime) => {
  if (msgTime) {
    msgTime = msgTime.replace(/-/g, "/");
    let msgYear = new Date(msgTime).getFullYear();
    let curYear = new Date().getFullYear();
    if (msgYear < curYear) {
      return msgTime;
    } else {
      return msgTime.slice(5);
    }
  } else {
    return "";
  }
};

const getMessageStatusImg = (msg, flag) => {
  if (!flag || !msg.result) {
    return "";
  }
  return `<span id="${msg.ackid}_status" title="正在发送..." class="message-status message-status--loading" aria-label="正在发送"></span>`;
};

const escapeHtmlAttr = (value) => String(value)
  .replace(/&/g, "&amp;")
  .replace(/"/g, "&quot;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;");

const normalizeMessageMid = (mid) => {
  if (mid === undefined || mid === null || mid === "") {
    return "";
  }
  return String(mid);
};

const getReadMessageId = (data) => normalizeMessageMid(data && data.mid);

const getRawMessageContent = (data) => {
  if (!data || data.content === undefined || data.content === null) {
    return "";
  }
  return String(data.content);
};

const getReadStatus = (data) => {
  if (!data || data.read_status === undefined || data.read_status === null || data.read_status === "") {
    return 0;
  }
  const status = Number(data.read_status);
  if (status === 1 || status === 2) {
    return status;
  }
  return 0;
};

const rememberReadMessageContent = (mid, content) => {
  if (!mid) {
    return;
  }
  readReceiptState.messageContents[mid] = content || "";
};

const getReadMessageContentByMid = (mid) => {
  if (!mid || !Object.prototype.hasOwnProperty.call(readReceiptState.messageContents, mid)) {
    return "";
  }
  return readReceiptState.messageContents[mid];
};

const getFileTarget = (data) => {
  const contentHtml = `<img class="file-icon" src="${file_icon}" />
                    <div class="file-title single-line" style={{ width:'165px', whiteSpace:'nowrap'}}>${utils.truncateFileName(data.title, 185)}</div>
                    <div class="file-size">${utils.formatStorageSize(
                      data.size
                    )}</div>`;
  return data.content
    ? `<a href="${data.content}" target="_blank" class="inner-card">${contentHtml}</a>`
    : `<div class="inner-card">${contentHtml}</div>`;
};

const resolveVideoConfig = (msg) => {
  const result = { height: msg.height, width: msg.width };
  if (result.height > 180) {
    result.width = (180 * result.width) / result.height;
    result.height = 180;
  }
  if (result.width > 240) {
    result.height = (240 * result.height) / result.width;
    result.width = 240;
  }
  return result;
}

window.showImage = (event) => {
  // 发送 largeImg 消息到父窗口（SDK iframe）
  shelltool.postMessage({ type: "largeImg", data: { url: event.target.src } });
};

window.showVideo = (event) => {
  event.stopPropagation();
  const targetSrc = event.target.dataset.src;
  if(targetSrc && targetSrc.indexOf('https://cdn.wykefu.com/') == -1) {
    return;
  }

  shelltool.postMessage({ type: "previewVideo", data: { url: targetSrc } });
};

const createMessageHtml = (data, params) => {
  params = params || {};
  const rightMsg = params.rightMessage || data.uid == data.from_uid;
  const readMessageId = getReadMessageId(data);
  const readMessageContent = getRawMessageContent(data);
  const readSource = params.readSource || "";
  const readStatus = getReadStatus(data);
  const canReportRead = !rightMsg && readMessageId && (readStatus === 0 || readStatus === 1);
  const statusSending = getMessageStatusImg(data, rightMsg);
  const htmlId = readMessageId ? "mid_" + readMessageId : data.ackid;
  let msgContent = "";

  switch (data.msgtype) {
    case "system": {
      if (params.createNode) {
        const messageItem = document.createElement("div");
        messageItem.className = "message-tag";
        messageItem.innerHTML = `<div class="content">${getReadableMsgTime(
          data.ctime
        )} ${data.content}</div>`;
        return messageItem;
      }
      return `<div class="message-tag">
                <div class="content">${getReadableMsgTime(data.ctime)} ${
        data.content
      }</div>
              </div>`;
    }
    case "emotion":
    case "image": {
      msgContent = `<div class="message-img">
            ${statusSending}
            <img id="${htmlId}_img" class="msg-img link-style" onclick="showImage(event)" src="${data.content}" />
            </div>`;
      break;
    }
    case "file": {
      msgContent = `<div class="inner-card-outer" id="${htmlId}_outer">
                ${statusSending}
                ${getFileTarget(data)}
            </div>`;
      break;
    }
    case "video": {
      const { height, width } = resolveVideoConfig(data);
      const duration = Math.ceil(data.duration || 0);
      const result = duration % 60;
      msgContent = `<div id="${htmlId}_video" class="message-video message-img" onclick="showVideo(event)" data-src="${data.content}" style="width:${width}px; height:${height}px; background-image: url(${data.thumb}); background-size: cover;">
            ${statusSending}
            <div class="video-play-btn" id="${htmlId}_video_btn" style="opacity:${data.content ? 1 : 0}" onclick="showVideo(event)" data-src="${data.content}"></div>
            <div class="v-duration" id="${htmlId}_video_duration">${parseInt(duration / 60) + (result < 10 ? `:0${result}` : `:${result}`)}</div>
            </div>`;
      break;
    }
    case "link": {
      msgContent = `<div class="inner-card-outer" id="${htmlId}_outer">
              <a href=${data.thumb_url} target="_blank" class="inner-card">
                <div class="content-img" style="background-image: url(${data.content})"></div>
                <div class="content-title">${data.title}</div>
                <div class="content-des">${data.description}</div>
                </a>
            </div>`;
      break;
    }
    default: {
      let RMsg = utils.linkifyText(utils.replaceTag(data.content));
      let LMsg = utils.linkifyText(data.content.indexOf('<') > -1 && data.content.indexOf('>') > -1 ? utils.replaceSpecialTag(data.content) : data.content);
      const emotionParsedRContent = qqWechatEmotionParser(RMsg);
      const emotionParsedLContent = qqWechatEmotionParser(LMsg);
      msgContent = `
        <span class="message-text">
          ${statusSending}
          <pre>${rightMsg ? emotionParsedRContent : emotionParsedLContent}</pre>
        </span>
      `;
      break;
    }
  }
  let fromName = data.from_name || "";
  if (!rightMsg && loginData.kefu_name_from) {
    fromName = loginData.kefu_name_from;
  }
  if (!rightMsg && readMessageId) {
    rememberReadMessageContent(readMessageId, readMessageContent);
  }
  if (params.createNode) {
    const messageItem = document.createElement("div");
    messageItem.id = htmlId;
    messageItem.className = `message-item${rightMsg ? " message-right" : " message-incoming"}`;
    if (readMessageId) {
      messageItem.setAttribute("data-mid", readMessageId);
    }
    if (!rightMsg && readMessageId) {
      messageItem.setAttribute("data-read-status", String(readStatus));
    }
    if (canReportRead) {
      messageItem.setAttribute("data-read-target", "1");
      if (readSource) {
        messageItem.setAttribute("data-read-source", readSource);
      }
    }
    messageItem.innerHTML = `<div class="name">${fromName} ${getReadableMsgTime(
      data.ctime
    )}</div>
        ${msgContent}
        <div class="clear-both"></div>`;
    return messageItem;
  }
  const messageMidAttr = readMessageId ? ` data-mid="${escapeHtmlAttr(readMessageId)}"` : "";
  const readStatusAttr = !rightMsg && readMessageId ? ` data-read-status="${readStatus}"` : "";
  const readTargetAttr = canReportRead ? ' data-read-target="1"' : "";
  const readSourceAttr = readTargetAttr && readSource ? ` data-read-source="${escapeHtmlAttr(readSource)}"` : "";
  return `<div class="message-item${
    rightMsg ? " message-right" : " message-incoming"
  }" id="${htmlId}"${messageMidAttr}${readStatusAttr}${readTargetAttr}${readSourceAttr}>
        <div class="name">${fromName} ${getReadableMsgTime(data.ctime)}</div>
        ${msgContent}
        <div class="clear-both"></div>
        </div>`;
};

const getMessageListElement = () => document.getElementById("msg-wrapper");

// 记录 HTTP 已确认的 mid，过滤同一消息的 WebSocket 回推。
const MESSAGE_MID_CACHE_TTL = 10 * 60 * 1000;
const MESSAGE_MID_CACHE_PRUNE_INTERVAL = 60 * 1000;
const messageMidCache = Object.create(null);
let nextMessageMidCachePruneAt = 0;

const getMessageElementByMid = (mid) => {
  const messageMid = normalizeMessageMid(mid);
  return messageMid ? document.getElementById("mid_" + messageMid) : null;
};

const pruneMessageMidCache = (now) => {
  Object.keys(messageMidCache).forEach((key) => {
    if (now - messageMidCache[key] > MESSAGE_MID_CACHE_TTL) {
      delete messageMidCache[key];
    }
  });
  nextMessageMidCachePruneAt = now + MESSAGE_MID_CACHE_PRUNE_INTERVAL;
};

const rememberMessageMid = (mid) => {
  const messageMid = normalizeMessageMid(mid);
  if (!messageMid) {
    return;
  }
  const now = new Date().getTime();
  if (now >= nextMessageMidCachePruneAt) {
    pruneMessageMidCache(now);
  }
  messageMidCache[messageMid] = now;
};

const isMessageMidRemembered = (mid) => {
  const messageMid = normalizeMessageMid(mid);
  if (!messageMid) {
    return false;
  }
  const rememberedAt = messageMidCache[messageMid];
  if (rememberedAt === undefined) {
    return false;
  }
  if (new Date().getTime() - rememberedAt > MESSAGE_MID_CACHE_TTL) {
    delete messageMidCache[messageMid];
    return false;
  }
  return true;
};

const filterDuplicateMessages = (messages, checkExistingDom) => {
  const seenMids = Object.create(null);
  return (messages || []).filter((item) => {
    const messageMid = getReadMessageId(item);
    // 没有 mid 的消息不参与去重，保持正常展示。
    if (!messageMid) {
      return true;
    }
    if (Object.prototype.hasOwnProperty.call(seenMids, messageMid)) {
      return false;
    }
    seenMids[messageMid] = true;
    return !checkExistingDom || !getMessageElementByMid(messageMid);
  });
};

const getLatestClientId = () => {
  const channelId = urlParams.channel_id || localStorage.getItem("zhini_channel_id") || "";
  return window._ZHINI_INIT_CLIENT_ID ||
    localStorage.getItem("zhini_init_client_id_" + channelId) ||
    localStorage.getItem("zhini_client_id_" + channelId) ||
    "";
};

const getInitUserStorageKey = (channelId, field) => {
  return "zhini_init_user_" + field + "_" + channelId;
};

const isValidAvatarUrl = (value) => {
  if (typeof value !== "string") {
    return false;
  }
  const url = value.trim();
  if (!/^https?:\/\//i.test(url)) {
    return false;
  }
  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname || "";
    return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(pathname);
  } catch (err) {}
  return false;
};

const getStoredInitUserValue = (channelId, field) => {
  if (!channelId) {
    return "";
  }
  try {
    return localStorage.getItem(getInitUserStorageKey(channelId, field)) || "";
  } catch (err) {}
  return "";
};

const getLatestInitUserInfo = () => {
  const channelId = urlParams.channel_id || localStorage.getItem("zhini_channel_id") || "";
  const avatar = window._ZHINI_INIT_USER_AVATAR || getStoredInitUserValue(channelId, "avatar");
  return {
    name: window._ZHINI_INIT_USER_NAME || getStoredInitUserValue(channelId, "name"),
    avatar: isValidAvatarUrl(avatar) ? avatar : "",
  };
};

const applyInitUserParams = (params) => {
  const initUserInfo = getLatestInitUserInfo();
  delete params.name;
  delete params.nickname;
  delete params.avatar;
  if (initUserInfo.name) {
    params.name = initUserInfo.name;
  }
  if (initUserInfo.avatar) {
    params.avatar = initUserInfo.avatar;
  }
};

const buildNewloginRequestData = () => {
  const requestData = {};
  const appendIfPresent = (key) => {
    const value = urlParams[key];
    if (value !== undefined && value !== null && value !== "") {
      requestData[key] = value;
    }
  };
  ["channel_id", "client_id", "name", "avatar", "domain"].forEach(appendIfPresent);
  requestData.location = urlParams.location || "";
  requestData.adddomain = true;
  return requestData;
};

const getReadReceiptStorageKey = () => {
  const channelId = urlParams.channel_id || localStorage.getItem("zhini_channel_id") || "";
  return READ_RECEIPT_QUEUE_STORAGE_PREFIX + channelId + "_" + getLatestClientId();
};

const getReadReceiptUrl = () => {
  return "/wykf/api/v1/enterprise/message/read";
};

const isChatPanelOpen = () => shelltool.getifameState() === 1;

const updateReadReceiptWindowState = () => {
  readReceiptState.pageVisible = document.visibilityState !== "hidden" && !document.hidden;
  readReceiptState.pageFocused = readReceiptState.pageVisible;
};

const clearPendingReadTimer = () => {
  if (readReceiptState.pendingTimerId) {
    clearTimeout(readReceiptState.pendingTimerId);
  }
  readReceiptState.pendingTimerId = null;
  readReceiptState.pendingReadMid = "";
  readReceiptState.pendingSeenMids = [];
};

const getReadReceiptMessageNodes = () => {
  const list = getMessageListElement();
  if (!list) {
    return [];
  }
  return Array.prototype.slice.call(list.querySelectorAll('[data-read-target="1"][data-mid]'));
};

const getVisibleIncomingMids = () => {
  const list = getMessageListElement();
  if (!list) {
    return [];
  }
  const listRect = list.getBoundingClientRect();
  return getReadReceiptMessageNodes().filter((item) => {
    const rect = item.getBoundingClientRect();
    const visibleTop = Math.max(rect.top, listRect.top);
    const visibleBottom = Math.min(rect.bottom, listRect.bottom);
    const visibleHeight = Math.max(0, visibleBottom - visibleTop);
    const readableHeight = Math.min(rect.height, listRect.height);
    const visibleRatio = readableHeight > 0 ? visibleHeight / readableHeight : 0;
    return visibleRatio >= READ_VISIBLE_RATIO;
  }).map((item) => item.getAttribute("data-mid"));
};

const isNearMessageBottom = () => {
  const list = getMessageListElement();
  if (!list) {
    return true;
  }
  return list.scrollHeight - list.scrollTop - list.clientHeight < 48;
};

const areSameMids = (left, right) => {
  if (left.length !== right.length) {
    return false;
  }
  return left.every((mid, index) => mid === right[index]);
};

const getLastMidByDomOrder = (mids) => {
  const midMap = {};
  mids.forEach((mid) => {
    midMap[mid] = true;
  });
  const nodes = getReadReceiptMessageNodes();
  for (let index = nodes.length - 1; index >= 0; index--) {
    const mid = nodes[index].getAttribute("data-mid");
    if (midMap[mid]) {
      return mid;
    }
  }
  return "";
};

const getReadCandidate = () => {
  const nodes = getReadReceiptMessageNodes();
  const reportedMid = readReceiptState.lastReportedReadMid;
  const hasReportedNode = !!reportedMid && nodes.some((node) => node.getAttribute("data-mid") === reportedMid);
  let shouldCheck = !reportedMid || !hasReportedNode;
  let candidate = reportedMid;

  for (let index = 0; index < nodes.length; index++) {
    const mid = nodes[index].getAttribute("data-mid");
    if (!mid) {
      continue;
    }
    if (!shouldCheck) {
      if (mid === reportedMid) {
        shouldCheck = true;
      }
      continue;
    }
    if (mid === candidate) {
      continue;
    }
    if (!readReceiptState.seenIncomingMids[mid]) {
      break;
    }
    candidate = mid;
  }

  return candidate;
};

const canAdvanceReadMid = (mid) => {
  if (!mid || mid === readReceiptState.lastReportedReadMid) {
    return false;
  }
  if (!readReceiptState.lastReportedReadMid) {
    return true;
  }
  const nodes = getReadReceiptMessageNodes();
  let candidateIndex = -1;
  let reportedIndex = -1;
  for (let index = 0; index < nodes.length; index++) {
    const nodeMid = nodes[index].getAttribute("data-mid");
    if (nodeMid === mid) {
      candidateIndex = index;
    }
    if (nodeMid === readReceiptState.lastReportedReadMid) {
      reportedIndex = index;
    }
  }
  if (candidateIndex !== -1 && reportedIndex !== -1) {
    return candidateIndex > reportedIndex;
  }
  return true;
};

const isReadMidCovered = (candidateMid, targetMid) => {
  if (!candidateMid || !targetMid) {
    return false;
  }
  if (candidateMid === targetMid) {
    return true;
  }
  const nodes = getReadReceiptMessageNodes();
  let candidateIndex = -1;
  let targetIndex = -1;
  for (let index = 0; index < nodes.length; index++) {
    const nodeMid = nodes[index].getAttribute("data-mid");
    if (nodeMid === candidateMid) {
      candidateIndex = index;
    }
    if (nodeMid === targetMid) {
      targetIndex = index;
    }
  }
  return candidateIndex !== -1 && targetIndex !== -1 && candidateIndex >= targetIndex;
};

const isReportableReadMid = (mid) => {
  if (!mid) {
    return false;
  }
  const nodes = getReadReceiptMessageNodes();
  for (let index = 0; index < nodes.length; index++) {
    if (nodes[index].getAttribute("data-mid") === mid) {
      const readStatus = nodes[index].getAttribute("data-read-status");
      return readStatus === "0" || readStatus === "1";
    }
  }
  return false;
};

const normalizeReadMids = (mids) => {
  const source = Array.isArray(mids) ? mids : [mids];
  const midMap = {};
  const result = [];
  source.forEach((mid) => {
    if (mid && !midMap[mid]) {
      midMap[mid] = true;
      result.push(mid);
    }
  });
  return result;
};

const getReportableReadMidsThrough = (targetMid) => {
  if (!targetMid) {
    return [];
  }
  const nodes = getReadReceiptMessageNodes();
  const reportedMid = readReceiptState.lastReportedReadMid;
  const hasReportedNode = !!reportedMid && nodes.some((node) => node.getAttribute("data-mid") === reportedMid);
  let shouldCollect = !reportedMid || !hasReportedNode;
  const mids = [];
  for (let index = 0; index < nodes.length; index++) {
    const mid = nodes[index].getAttribute("data-mid");
    if (!mid) {
      continue;
    }
    if (!shouldCollect) {
      if (mid === reportedMid) {
        shouldCollect = true;
      }
      continue;
    }
    if (readReceiptState.seenIncomingMids[mid] && isReportableReadMid(mid)) {
      mids.push(mid);
    }
    if (mid === targetMid) {
      break;
    }
  }
  return mids;
};

const setNewMessageHintVisible = (visible) => {
  readReceiptState.showNewMessageHint = visible;
  const hint = document.getElementById("read-new-message-hint");
  if (hint) {
    hint.style.display = visible ? "block" : "none";
  }
};

const ensureNewMessageHint = () => {
  let hint = document.getElementById("read-new-message-hint");
  if (hint) {
    return hint;
  }
  const container = document.querySelector(".body-left") || document.querySelector(".chat-body") || document.body;
  if (!container) {
    return null;
  }
  hint = document.createElement("button");
  hint.id = "read-new-message-hint";
  hint.className = "read-new-message-hint";
  hint.type = "button";
  hint.innerText = "有新消息，点击回到底部";
  hint.style.display = "none";
  hint.onclick = function () {
    setNewMessageHintVisible(false);
    utils.scrollDownEnd(undefined, 0);
    scheduleReadReceiptCheck(350);
  };
  container.appendChild(hint);
  return hint;
};

const queueReadReceipt = (mid) => {
  if (!mid) {
    return;
  }
  readReceiptState.queuedReadMid = mid;
  try {
    localStorage.setItem(getReadReceiptStorageKey(), mid);
  } catch (err) {}
};

const clearQueuedReadReceipt = () => {
  readReceiptState.queuedReadMid = "";
  try {
    localStorage.removeItem(getReadReceiptStorageKey());
  } catch (err) {}
};

const hydrateQueuedReadReceipt = () => {
  if (readReceiptState.queuedReadMid) {
    return;
  }
  try {
    readReceiptState.queuedReadMid = localStorage.getItem(getReadReceiptStorageKey()) || "";
  } catch (err) {}
};

const resolveLastReadMid = (payload) => {
  if (!payload) {
    return "";
  }
  if (payload.mid) {
    return String(payload.mid);
  }
  if (payload.lastReadMid) {
    return String(payload.lastReadMid);
  }
  if (payload.last_read_mid) {
    return String(payload.last_read_mid);
  }
  if (payload.readMid) {
    return String(payload.readMid);
  }
  if (payload.read_mid) {
    return String(payload.read_mid);
  }
  if (payload.data) {
    return resolveLastReadMid(payload.data);
  }
  return "";
};

const syncSeenIncomingMidsByDomOrder = () => {
  const reportedMid = readReceiptState.lastReportedReadMid;
  if (!reportedMid) {
    return;
  }
  const nodes = getReadReceiptMessageNodes();
  let reportedIndex = -1;
  for (let index = 0; index < nodes.length; index++) {
    if (nodes[index].getAttribute("data-mid") === reportedMid) {
      reportedIndex = index;
      break;
    }
  }
  if (reportedIndex === -1) {
    readReceiptState.seenIncomingMids[reportedMid] = true;
    return;
  }
  for (let index = 0; index <= reportedIndex; index++) {
    const mid = nodes[index].getAttribute("data-mid");
    if (mid) {
      readReceiptState.seenIncomingMids[mid] = true;
    }
  }
};

const markHistoryReadTargetsSeen = () => {
  const list = getMessageListElement();
  if (!list) {
    return;
  }
  Array.prototype.slice.call(list.querySelectorAll('.message-incoming[data-mid]')).forEach((node) => {
    const mid = node.getAttribute("data-mid");
    const readStatus = node.getAttribute("data-read-status");
    if (mid && readStatus === "2") {
      readReceiptState.seenIncomingMids[mid] = true;
    }
  });
};

const syncLastReportedReadMid = (payload) => {
  const lastReadMid = resolveLastReadMid(payload);
  if (!lastReadMid) {
    return false;
  }
  readReceiptState.lastReportedReadMid = lastReadMid;
  readReceiptState.seenIncomingMids[lastReadMid] = true;
  syncSeenIncomingMidsByDomOrder();
  if (readReceiptState.queuedReadMid === lastReadMid || isReadMidCovered(lastReadMid, readReceiptState.queuedReadMid)) {
    clearQueuedReadReceipt();
  }
  return true;
};

const sendReadReceipt = (mids) => {
  const readMids = normalizeReadMids(mids);
  if (readMids.length === 0 || readReceiptState.isFlushing || !loginData.token) {
    return;
  }
  const lastMid = getLastMidByDomOrder(readMids) || readMids[readMids.length - 1];
  readReceiptState.isFlushing = true;
  ajaxUtils.httpRequest({
    type: "POST",
    url: getReadReceiptUrl(),
    contentType: "application/json; charset=UTF-8",
    data: {
      mids: readMids,
      read_status: 2,
      token: loginData.token,
    },
    success: (result) => {
      readReceiptState.lastReportedReadMid = resolveLastReadMid(result) || lastMid;
      readMids.forEach((mid) => {
        readReceiptState.seenIncomingMids[mid] = true;
      });
      readReceiptState.seenIncomingMids[readReceiptState.lastReportedReadMid] = true;
      clearQueuedReadReceipt();
      readReceiptState.isFlushing = false;
    },
    error: () => {
      if (!window.navigator.onLine) {
        queueReadReceipt(lastMid);
      } else if (readReceiptState.queuedReadMid === lastMid) {
        clearQueuedReadReceipt();
      }
      readReceiptState.isFlushing = false;
    },
  });
};

const attemptFlushQueuedReadReceipt = () => {
  hydrateQueuedReadReceipt();
  if (!readReceiptState.queuedReadMid || !window.navigator.onLine || readReceiptState.isFlushing) {
    return;
  }
  if (!isReportableReadMid(readReceiptState.queuedReadMid)) {
    clearQueuedReadReceipt();
    return;
  }
  if (
    readReceiptState.queuedReadMid === readReceiptState.lastReportedReadMid ||
    isReadMidCovered(readReceiptState.lastReportedReadMid, readReceiptState.queuedReadMid)
  ) {
    clearQueuedReadReceipt();
    return;
  }
  const queuedReadMids = getReportableReadMidsThrough(readReceiptState.queuedReadMid);
  sendReadReceipt(queuedReadMids.length ? queuedReadMids : readReceiptState.queuedReadMid);
};

const confirmVisibleReadMids = (mids) => {
  readReceiptState.pendingTimerId = null;
  updateReadReceiptWindowState();
  const visibleMidMap = {};
  getVisibleIncomingMids().forEach((mid) => {
    visibleMidMap[mid] = true;
  });
  const confirmedMids = mids.filter((mid) => visibleMidMap[mid]);
  if (!isChatPanelOpen() || !readReceiptState.pageVisible || !readReceiptState.pageFocused || confirmedMids.length === 0) {
    return;
  }
  confirmedMids.forEach((mid) => {
    readReceiptState.seenIncomingMids[mid] = true;
  });
  readReceiptState.pendingReadMid = "";
  readReceiptState.pendingSeenMids = [];
  const readMids = confirmedMids.filter((mid) => isReportableReadMid(mid));
  if (readMids.length === 0) {
    return;
  }
  const readCandidate = getLastMidByDomOrder(readMids) || readMids[readMids.length - 1];
  if (!window.navigator.onLine) {
    queueReadReceipt(readCandidate);
    return;
  }
  sendReadReceipt(readMids);
};

const reevaluateReadReceiptCandidate = () => {
  updateReadReceiptWindowState();
  if (!isChatPanelOpen() || !readReceiptState.pageVisible || !readReceiptState.pageFocused) {
    clearPendingReadTimer();
    return;
  }
  const visibleMids = getVisibleIncomingMids();
  const candidate = getReadCandidate();
  if (isReadMidCovered(candidate, readReceiptState.queuedReadMid)) {
    attemptFlushQueuedReadReceipt();
  }
  const pendingMids = visibleMids.filter((mid) => !readReceiptState.seenIncomingMids[mid] && isReportableReadMid(mid));
  if (pendingMids.length === 0) {
    clearPendingReadTimer();
    return;
  }
  const pendingReadMid = getLastMidByDomOrder(pendingMids);
  if (
    readReceiptState.pendingTimerId &&
    readReceiptState.pendingReadMid === pendingReadMid &&
    areSameMids(readReceiptState.pendingSeenMids, pendingMids)
  ) {
    return;
  }
  clearPendingReadTimer();
  readReceiptState.pendingReadMid = pendingReadMid;
  readReceiptState.pendingSeenMids = pendingMids;
  readReceiptState.pendingTimerId = setTimeout(() => {
    confirmVisibleReadMids(pendingMids);
  }, READ_DWELL_MS);
};

const scheduleReadReceiptCheck = (delay) => {
  setTimeout(reevaluateReadReceiptCandidate, delay || 0);
};

const scheduleReadReceiptLayoutCheck = (delay) => {
  if (readReceiptState.layoutCheckTimerId) {
    clearTimeout(readReceiptState.layoutCheckTimerId);
  }
  readReceiptState.layoutCheckTimerId = setTimeout(() => {
    readReceiptState.layoutCheckTimerId = null;
    reevaluateReadReceiptCandidate();
  }, delay || READ_LAYOUT_CHECK_DELAY);
};

const bindReadReceiptMediaLoad = (root) => {
  if (!root || !root.querySelectorAll) {
    return;
  }
  Array.prototype.slice.call(root.querySelectorAll("img")).forEach((img) => {
    if (img.getAttribute("data-read-receipt-load-bound") === "1") {
      return;
    }
    img.setAttribute("data-read-receipt-load-bound", "1");
    img.addEventListener("load", () => {
      scheduleReadReceiptLayoutCheck();
    });
    img.addEventListener("error", () => {
      scheduleReadReceiptLayoutCheck();
    });
    if (img.complete) {
      scheduleReadReceiptLayoutCheck();
    }
  });
};

const observeReadReceiptNodes = (root) => {
  if (!root || !root.querySelectorAll || !readReceiptState.resizeObserver) {
    return;
  }
  const nodes = root.matches && root.matches('[data-read-target="1"][data-mid]')
    ? [root]
    : Array.prototype.slice.call(root.querySelectorAll('[data-read-target="1"][data-mid]'));
  nodes.forEach((node) => {
    if (node.getAttribute("data-read-receipt-observed") === "1") {
      return;
    }
    node.setAttribute("data-read-receipt-observed", "1");
    readReceiptState.resizeObserver.observe(node);
  });
};

const initReadReceiptLayoutWatcher = (list) => {
  if (!list) {
    return;
  }
  bindReadReceiptMediaLoad(list);
  if (window.ResizeObserver && !readReceiptState.resizeObserver) {
    readReceiptState.resizeObserver = new ResizeObserver(() => {
      scheduleReadReceiptLayoutCheck();
    });
    observeReadReceiptNodes(list);
  }
  if (window.MutationObserver && !readReceiptState.mutationObserver) {
    readReceiptState.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        Array.prototype.slice.call(mutation.addedNodes).forEach((node) => {
          bindReadReceiptMediaLoad(node);
          observeReadReceiptNodes(node);
        });
      });
      scheduleReadReceiptLayoutCheck();
    });
    readReceiptState.mutationObserver.observe(list, {
      childList: true,
      subtree: true,
    });
  }
};

const initReadReceiptWatcher = () => {
  if (readReceiptState.initialized) {
    return;
  }
  readReceiptState.initialized = true;
  hydrateQueuedReadReceipt();
  ensureNewMessageHint();
  const list = getMessageListElement();
  if (list) {
    initReadReceiptLayoutWatcher(list);
    list.addEventListener("scroll", () => {
      if (isNearMessageBottom()) {
        setNewMessageHintVisible(false);
      }
      reevaluateReadReceiptCandidate();
    });
  }
  window.addEventListener("focus", reevaluateReadReceiptCandidate);
  window.addEventListener("blur", reevaluateReadReceiptCandidate);
  window.addEventListener("online", attemptFlushQueuedReadReceipt);
  window.addEventListener("resize", scheduleReadReceiptLayoutCheck);
  document.addEventListener("visibilitychange", reevaluateReadReceiptCandidate);
  window.handleZhiniPanelOpen = function () {
    setNewMessageHintVisible(false);
    scheduleReadReceiptCheck(350);
  };
  window.handleZhiniPanelClose = function () {
    clearPendingReadTimer();
  };
};

let isRequestMessageListLoading = false;
// 页面级状态不写入浏览器存储，刷新或新开 Tab 时都会重新初始化。
const getPageConnectionState = () => {
  if (!window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__) {
    window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__ = {
      wsOpened: false,
      initialMessageListLoaded: false,
    };
  }
  return window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__;
};

const requestMessageList = (history, cb, options = {}) => {
  if (!history && isRequestMessageListLoading) {
    return;
  }
  if (!history) {
    isRequestMessageListLoading = true;
  }
  const params = { token: loginData.token };
  let historyElement;
  if (history) {
    historyElement = document.getElementById("more-history");
    historyElement.children[0].style.display = "none";
    historyElement.children[1].style.display = "block";
    params.forward = 1;
    params.mid = lastMid;
  }
  params.version = "0.1.3";
  const latestClientId = localStorage.getItem('zhini_init_client_id_'+ urlParams.channel_id) || localStorage.getItem('zhini_client_id_'+ urlParams.channel_id);
  if (latestClientId) {
    params.client_id = latestClientId;
  }
  ajaxUtils.httpRequest({
    url: "/wykf/api/v1/enterprise/webplugin/message",
    data: params,
    success: (result) => {
      if (!history) {
        isRequestMessageListLoading = false;
      }
      syncLastReportedReadMid(result.data);
      const msg = result.data.msg || [];
      const displayMsg = filterDuplicateMessages(msg, !!history);
      messageLength += msg.length;
      msg.length && (lastMid = msg[0].mid);
      const readSource = history ? "more-history" : "initial-history";
      const resultHtml = displayMsg.map((item) => createMessageHtml(item, { readSource }));
      if (history) {
        const node = document.getElementById("msg-wrapper");
        const newNode = document.createElement("div");
        newNode.innerHTML = resultHtml.join("");
        node.insertBefore(newNode, node.childNodes[1]);
        markHistoryReadTargetsSeen();
        // 滚动到指定消息位置
        let msgWrapperRef = document.getElementById("msg-wrapper");
        if(msgWrapperRef && msg.length) {
          const lastMsgInBatch = msg[msg.length - 1];
          if(lastMsgInBatch && normalizeMessageMid(lastMsgInBatch.mid)) {
            const targetElement = getMessageElementByMid(lastMsgInBatch.mid);
            if(targetElement) {
              targetElement.scrollIntoView({
                block: "start",
              });
            }
          }
        }

        if (msg.length < 10) {
          historyElement.innerHTML = '<div class="content">没有更多了！</div>';
          setTimeout(() => {
            historyElement[
              utils.IsIE || utils.IsIE11 ? "removeNode" : "remove"
            ](true);
          }, 3000);
        } else {
          historyElement.children[0].style.display = "block";
          historyElement.children[1].style.display = "none";
        }
        scheduleReadReceiptCheck(350);
      } else {
        document.getElementById("msg-wrapper").innerHTML =
          (msg.length < 10
            ? ""
            : '<div id="more-history"><div onclick="requestMessageList(1)" class="content">加载更多历史消息</div><div style="display: none;" class="content">加载中...</div></div>') +
          resultHtml.join("");
        markHistoryReadTargetsSeen();
        utils.scrollDownEnd();
        setNewMessageHintVisible(false);
        scheduleReadReceiptCheck(350);
        window.requestHis = true;
        cb && cb(1)
        const shouldShowRecoveryMessage =
          !history && options.showRecoveryMessage === true && getPageConnectionState().initialMessageListLoaded;
        if (!history) {
          getPageConnectionState().initialMessageListLoaded = true;
        }
        if (shouldShowRecoveryMessage) {
            const sysMsg = {
              msgtype: "system",
              content: "连接已恢复！",
              mid: "native_" + new Date().getTime(),
            };
          showMoreMessage(sysMsg, true);
        }
      }
    },
    error: (error) => {
      if (!history) {
        isRequestMessageListLoading = false;
      }
      if (history) {
        historyElement.children[0].style.display = "block";
        historyElement.children[1].style.display = "none";
      }
      if (error && (error.sta === 10003 || error.errcode === 10003)) {
        startProcess({
          errcode: 10003,
          token: error.token || loginData.token,
          type: "needMsgList",
        });
      }
    },
  });
};

window.requestMessageList = requestMessageList;

const initEmojiFunction = () => {
  document.getElementById("emoji-btn").onclick = function () {
    let emojiDialog = document.getElementById("emoji-dialog");
    if (emojiDialog) {
      emojiDialog.style.display = "block";
    } else {
      emojiDialog = document.createElement("div");
      emojiDialog.id = "emoji-dialog";
      emojiDialog.innerHTML = `<div class="qq-emo-c" style="width:${
        utils.IsPcMode ? "440px" : "95%"
      }">
                ${window._qqWechatEmotionParser.emotion_map
                  .map((item, index) =>
                    item
                      .map(
                        (
                          cItem,
                          cIndex
                        ) => `<img class="wx-emo-img link-style" style="background-position: ${
                          -28 * cIndex
                        }px ${-28 * index}px"
                                    src="https://wx.qq.com/zh_CN/htmledition/v2/images/spacer.gif"
                                    alt="${cItem.cn}" />`
                      )
                      .join("")
                  )
                  .join("")}
            </div>`;

      emojiDialog.onclick = (event) => {
        if (event.target.className == "qq-emo-c") {
          return;
        }
        const element = document.getElementById("textarea");
        const newValue = event.target.alt;
        emojiDialog.style.display = "none";
        if (!newValue) {
          return;
        }
        let start = element.selectionStart;
        element.value =
          element.value.slice(0, start) + newValue + element.value.slice(start);
        start += newValue.length;
        element.focus();
        element.setSelectionRange(start, start);
      };
      document.body.appendChild(emojiDialog);
    }
  };
};

const WS_UNAVAILABLE_MESSAGE = "网络异常，请刷新后重新打开客服窗口发送消息";
let wsUnavailableToastTimer = null;

const showWsUnavailableToast = () => {
  const container =
    document.querySelector(".body-left") ||
    document.querySelector(".chat-body") ||
    document.body;
  if (!container) {
    return;
  }
  const computedPosition = window.getComputedStyle(container).position;
  if (!computedPosition || computedPosition === "static") {
    container.style.position = "relative";
  }
  let toast = document.getElementById("ws-unavailable-toast");
  if (!toast) {
    toast = document.createElement("div");
    toast.id = "ws-unavailable-toast";
    toast.innerHTML =
      '<span class="ws-unavailable-toast__icon">!</span><span class="ws-unavailable-toast__text"></span>';
    toast.style.cssText =
      "position:absolute;left:50%;bottom:116px;transform:translateX(-50%);z-index:30;display:flex;align-items:center;gap:8px;max-width:calc(100% - 32px);padding:10px 14px;border-radius:18px;background:rgba(0,0,0,.78);color:#fff;font-size:13px;line-height:18px;box-shadow:0 8px 20px rgba(0,0,0,.2);";
    const icon = toast.querySelector(".ws-unavailable-toast__icon");
    icon.style.cssText =
      "flex:0 0 18px;width:18px;height:18px;border-radius:50%;background:#ff4d4f;color:#fff;font-weight:700;font-size:13px;line-height:18px;text-align:center;";
    const text = toast.querySelector(".ws-unavailable-toast__text");
    text.style.cssText = "word-break:break-all;";
    container.appendChild(toast);
  }
  toast.querySelector(".ws-unavailable-toast__text").textContent =
    WS_UNAVAILABLE_MESSAGE;
  toast.style.display = "flex";
  if (wsUnavailableToastTimer) {
    clearTimeout(wsUnavailableToastTimer);
  }
  wsUnavailableToastTimer = setTimeout(() => {
    toast.style.display = "none";
  }, 2500);
};

const markMessageAsFailed = (nextItem, canRetry) => {
  const node = document.getElementById(nextItem.ackid + "_status");
  if (!node) {
    return;
  }
  node.className = "message-status message-status--failed";
  node.removeAttribute("aria-label");
  node.title = canRetry ? "消息发送失败，点击重新发送" : "发送失败";
  node.onclick = null;
  node.style.cursor = canRetry ? "pointer" : "default";
  if (canRetry) {
    node.onclick = function () {
      node.className = "message-status message-status--loading";
      node.setAttribute("aria-label", "正在发送");
      node.title = "发送中...";
      node.style.cursor = "default";
      setTimeout(() => {
        if (typeof nextItem.retryAction === "function") {
          nextItem.retryAction();
          return;
        }
        sendMessage(nextItem, 1);
      }, 1000);
    };
  }
};

const ensureWsAvailable = (nextItem, options = {}) => {
  if (wsUtils.isWsAvailable()) {
    return true;
  }
  if (wsUtils.isCurrentConsultingActive && wsUtils.isCurrentConsultingActive()) {
    wsUtils.startProcess("setConsultingActive", { active: true, reason: "ensure_ws_available" });
    return true;
  }
  if (
    nextItem &&
    options.showMessage &&
    !document.getElementById(nextItem.ackid)
  ) {
    showMoreMessage(nextItem);
  }
  showWsUnavailableToast();
  nextItem && markMessageAsFailed(nextItem, !!options.canRetry);
  return false;
};

const sendMessage = (nextItem, sendCount) => {
  if (!ensureWsAvailable(nextItem, { canRetry: true })) {
    return false;
  }
  wsUtils.startProcess("sendMsgH", {
    message: nextItem,
    sendCount,
    cb: (status, data = {}, sendCount) => {
      if (status < 0) {
        if (sendCount < 4) {
          if (data.errcode === 10003) {
            startProcess({ errcode: data.errcode, token: data.token });
            setTimeout(() => {
              // FIXME 此处等待3秒待处理成实时获取ws_reconnect_suc的状态
              delete nextItem.ctime;
              delete nextItem.result;
              sendMessage(nextItem, sendCount);
            }, 3000);
            return;
          }
          setTimeout(() => {
            delete nextItem.ctime;
            delete nextItem.result;
            sendMessage(nextItem, sendCount);
          }, 1000);
        }
        markMessageAsFailed(nextItem, true);
      } else {
        const messageMid = normalizeMessageMid(data.mid);
        if (messageMid) {
          rememberMessageMid(messageMid);
          const pendingNode = document.getElementById(nextItem.ackid);
          const echoedNode = getMessageElementByMid(messageMid);
          if (pendingNode) {
            // WebSocket 可能先于 HTTP 回调到达，删除它生成的重复节点，保留本地发送节点。
            if (echoedNode && echoedNode !== pendingNode) {
              echoedNode[utils.IsIE || utils.IsIE11 ? "removeNode" : "remove"](true);
            }
            pendingNode.id = "mid_" + messageMid;
          }
        }
        if (nextItem.msgtype == "file") {
          delete nextItem.result;
          document.getElementById(nextItem.ackid + "_outer").innerHTML =
            getFileTarget(nextItem);
        } else {
          document
            .getElementById(nextItem.ackid + "_status")
            [utils.IsIE || utils.IsIE11 ? "removeNode" : "remove"](true);
          if (
            urlParams.channel_id == "5ee1ff983dbf994471042f38" &&
            nextItem.msgtype === "text" &&
            data.content &&
            data.content != ""
          ) {
            //针对企微线上渠道优先展示后端返回的数据
            const messageNode = getMessageElementByMid(data.mid);
            if (messageNode) {
              const parent = messageNode.childNodes;
              for (let i = 0; i < parent.length; i++) {
                if (parent[i].className === "message-text") {
                  const childs = parent[i].childNodes;
                  for (let j = 0; j < childs.length; j++) {
                    if (childs[j].nodeName == "PRE") {
                      childs[j].innerHTML = utils.linkifyText(utils.replaceSpecialTag(data.content));
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
  });
  return true;
};

const showMoreMessage = (nextItem, noRight) => {
  const date = new Date();
  nextItem.ctime = utils.formatDate(date);
  nextItem.result = date.getTime();
  if(nextItem.msgtype == 'video' && nextItem.width == 0 && !nextItem.content) {
    nextItem.thumb = video_bg
  }
  document
    .getElementById("msg-wrapper")
    .appendChild(
      createMessageHtml(nextItem, { rightMessage: !noRight, createNode: true })
    );
  utils.scrollDownEnd();
};

const resolveFileInput = (
  event,
  files,
  nextItem,
  fileType,
  base64,
  showMore
) => {
  nextItem.retryAction = () =>
    resolveFileInput(event, files, nextItem, fileType, base64, true);
  if (!ensureWsAvailable(nextItem, { showMessage: true, canRetry: true })) {
    event && event.target && (event.target.value = "");
    return;
  }
  !showMore && !nextItem.thumb && showMoreMessage(nextItem);
  ajaxUtils.changeInputImg(
    loginData.token,
    files,
    base64,
    nextItem,
    (status, data) => {
        if (!status && data.cdn_url) {
          nextItem.content = data.cdn_url;
          if(data.thumb) nextItem.thumb = data.thumb;
          if(data.duration) nextItem.duration = data.duration;
          if(data.fsize) nextItem.size = data.fsize;
        if (fileType) {
          nextItem.size = data.fsize;
          nextItem.title = data.filename;
        } else {
          if(data.width && data.height){ //获取宽高渲染
            nextItem.height = data.height;
            nextItem.width = data.width;
            if(nextItem.msgtype == 'video'){
              const ele_btn = document.getElementById(nextItem.ackid + "_video_btn");
              if(ele_btn) {
                ele_btn.style.opacity = 1
              }
            }
          }
          if(nextItem.thumb) {
            if(data.cdn_url){ //获取视频内容渲染
              const ele = document.getElementById(nextItem.ackid + "_video");
              ele && ele.setAttribute("data-src", nextItem.content);
              const ele_btn = document.getElementById(nextItem.ackid + "_video_btn");
              ele_btn && ele_btn.setAttribute("data-src", nextItem.content);
            }
            if(data.thumb){ //获取封面渲染
              const ele = document.getElementById(nextItem.ackid + "_video");
              const { height, width } = resolveVideoConfig(data);
              if(ele){
                ele.style.backgroundImage = `url("${nextItem.thumb}")`;
                ele.style.width = `${width}px`;
                ele.style.height = `${height}px`;
              }
            }
            if(data.duration){ //获取时长渲染
              const duration = data.duration || 0;
              const result = duration % 60;
              const ele_duration = document.getElementById(nextItem.ackid + "_video_duration");
              if(ele_duration){
                ele_duration.innerText = parseInt(duration / 60) + (result < 10 ? `:0${result}` : `:${result}`)
              }
            }
          }else{
            const ele = document.getElementById(nextItem.ackid + "_img");
            ele && ele.setAttribute("src", nextItem.content);
          }
        }
        nextItem.retryAction = () => sendMessage(nextItem, 1);
        sendMessage(nextItem, 1);
      }
      if (status) {
        if (data.errcode === 10003) {
          startProcess({ errcode: data.errcode, token: data.token });
          setTimeout(() => {
            delete nextItem.ctime;
            delete nextItem.result;
            resolveFileInput(event, files, nextItem, fileType, base64, true);
          }, 3000);
          return;
        }
        let content = '';
        if (data.errcode === -1 || data.errcode === 600){
          content = data.msg
        }else{
          content = `上传失败，请刷新重试 ${data.errcode ? `（${data.errcode}）` : ''}`;
        }
        const sysMsg = {
          msgtype: "system",
          content,
          mid: "native_" + new Date().getTime(),
        };
        showMoreMessage(sysMsg, true);
        markMessageAsFailed(nextItem, true);
        messageLength++;
      }
      event.target.value = "";
    }
  );
};

const resolveVideoBgImage = (files, nextItem, videoEvent, videoFile, msgItem) => {
  nextItem.retryAction = () =>
    resolveVideoBgImage(files, nextItem, videoEvent, videoFile, msgItem);
  if (!ensureWsAvailable(nextItem, { showMessage: true, canRetry: true })) {
    videoEvent && videoEvent.target && (videoEvent.target.value = "");
    return;
  }
  ajaxUtils.changeInputImg(
    loginData.token,
    files,
    undefined,
    msgItem,  // 传递 msgItem 以便设置 return_thumb 参数
    (status, data) => {
      if (!status && data.cdn_url) {
        nextItem.thumb = data.cdn_url; //封面图
        data.cdn_url && nextItem.thumb && showMoreMessage(nextItem);
        if(nextItem.msgtype == 'video'){
          const ele_btn = document.getElementById(nextItem.ackid + "_video_btn");
          if(ele_btn) {
            ele_btn.style.opacity = 1
          }
        }
        resolveFileInput(videoEvent, videoFile, nextItem);
      }
      if (status) {
        if (data.errcode === 10003) { // 重新登录
          startProcess({ errcode: data.errcode, token: data.token });
          return;
        }
        //上传失败弹出失败系统提示
        let content = '';
        if (data.errcode === -1 || data.errcode === 600){
          content = data.msg
        }else{
          content = `上传失败，请刷新重试 ${data.errcode ? `（${data.errcode}）` : ''}`;
        }
        const sysMsg = {
          msgtype: "system",
          content,
          mid: "native_" + new Date().getTime(),
        };
        !document.getElementById(nextItem.ackid) && showMoreMessage(nextItem);
        markMessageAsFailed(nextItem, true);
        showMoreMessage(sysMsg, true);
      }
    }
  );
};

const initActions = () => {
  const markConsultingTabActive = (reason) => {
    wsUtils.startProcess("setConsultingActive", { active: true, reason });
  };
  let lastBrowserTabActivatedAt = 0;
  // 浏览器 Tab 或独立窗口重新获得焦点时，先恢复当前 Tab 的 WebSocket。
  const activateCurrentBrowserTab = () => {
    if (document.visibilityState !== "visible") {
      return;
    }
    const now = new Date().getTime();
    if (now - lastBrowserTabActivatedAt < 100) {
      return;
    }
    lastBrowserTabActivatedAt = now;
    wsUtils.startProcess("setConsultingActive", {
      active: true,
      reason: "tab_visible",
      params: { reason: "tab_visible" },
    });
    // 连接已经可用时立即同步；连接恢复中的场景由 WebSocket onopen 负责同步。
    if (isChatPanelOpen() && wsUtils.isWsAvailable()) {
      requestMessageList(undefined, undefined, { showRecoveryMessage: false });
    }
  };
  window.handleZhiniTabVisible = activateCurrentBrowserTab;
  document.getElementById("send-btn").onclick = function () {
    markConsultingTabActive("send_button");
    sendTextArea();
  };
  const sendTextArea = () => {
    markConsultingTabActive("send_text");
    const element = document.getElementById("textarea");
    const message = element.value.trim();
    if (!message) {
      return;
    }
    const msgVal = utils.hasSensitiveWords(message)
    if(msgVal){
      const sysMsg = {
        msgtype: "system",
        content: "发送消息中包含敏感内容，请编辑后重试。",
        mid: "native_" + new Date().getTime(),
      };
      showMoreMessage(sysMsg, true);
      return
    }
    element.value = "";
    const nextItem = {
      content: utils.replaceTag(message),
      msgtype: "text",
      ackid: "msg_" + messageLength++,
    };
    showMoreMessage(nextItem);
    sendMessage(nextItem, 1);
  };
  const removeEventListeners = (videoElement) => {
    videoElement.removeEventListener('loadedmetadata', undefined);
    videoElement.removeEventListener('seeked', undefined);
  };
  const handleVideoBg = (file, event, files) =>{
    const videoElement = document.getElementById('video-preview');
    let videoDuration = 0, videoThumb = '', videoWidth = 0, videoHeight = 0, hasLogged = false, isProcessing = false;

    videoElement.src = URL.createObjectURL(file);
    videoElement.autoplay = true;
    videoElement.muted = true;

    videoElement.addEventListener('loadedmetadata', function() {
      if (isProcessing) return; // 如果已经在处理中，则直接返回
      isProcessing = true; // 标记为正在处理

      videoWidth = this.videoWidth;
      videoHeight = this.videoHeight;
      videoDuration = Math.floor(this.duration);

      if(!videoWidth && !videoHeight) {
        resolveFileInput(
          event,
          files,
          {
            msgtype: "file",
            title: file.name,
            size: file.size,
            ackid: "msg_" + messageLength++,
          },
          true
        );
        URL.revokeObjectURL(videoElement.src);
        videoElement.src = '';
        removeEventListeners(videoElement);
        return;
      }
      videoElement.currentTime = 0;
      videoElement.play();
    });

    videoElement.addEventListener('seeked', function() {
      if (hasLogged || !videoWidth || !videoHeight) return;
      const canvas = document.createElement('canvas');
      canvas.width = videoWidth;
      canvas.height = videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
      videoThumb = canvas.toDataURL('image/png'); // base64
      hasLogged = true; // 设置标志变量为 true，表示已经打印过日志
      videoElement.pause();
      const fileObject = utils.base64ToFile(videoThumb, `video_bg_${new Date().getTime()}`);
      const nextItem = {
        msgtype: "video",
        content: '',
        thumb: pic_uploading, //视频封面
        width: videoWidth, //视频宽
        height: videoHeight, // 视频高
        duration: videoDuration, // 时长
        size: file.size, // 文件的大小
        ackid: "msg_" + messageLength++,
      }
      resolveVideoBgImage([fileObject], nextItem, event, files, nextItem); // 上传视频封面
      URL.revokeObjectURL(videoElement.src);
      removeEventListeners(videoElement); // 移除所有事件监听器
    });

    videoElement.load();
  };
  const resolveSend = (event) => {
    const files = event.target.files;
    const file = files[0];

    if(utils.isImageFile(file.name)){
      // 图片限制10M - 提前检查
      if(file.size > 10 * 1024 * 1024){
        const sysMsg = {
          msgtype: "system",
          content: "图片的大小不能超过10M！",
          mid: "native_" + new Date().getTime(),
        };
        showMoreMessage(sysMsg, true);
        return;
      }

      resolveFileInput(event, files, {
        content: pic_uploading,
        msgtype: "image",
        ackid: "msg_" + messageLength++,
      });
    }else if(utils.isVideoFile(file.name)){
      // 处理视频发送
      if (file) {
        if(file.size > 25 * 1024 * 1024){
          const sysMsg = {
            msgtype: "system",
            content: "视频的大小不能超过25M！",
            mid: "native_" + new Date().getTime(),
          };
          showMoreMessage(sysMsg, true);
          return;
        }
        if(utils.isWindowsPC){
          handleVideoBg(file, event, files)
        }else{
          resolveFileInput(event, files, {
            msgtype: "video",
            content: '',
            thumb:'',
            width: 0,
            height: 0,
            duration: 0,
            size: 0,
            ackid: "msg_" + messageLength++,
          });
        }
      }
    }else{
      // 文件限制25M - 提前检查
      if(file.size > 25 * 1024 * 1024){
        const sysMsg = {
          msgtype: "system",
          content: "文件的大小不能超过25M！",
          mid: "native_" + new Date().getTime(),
        };
        showMoreMessage(sysMsg, true);
        return;
      }

      resolveFileInput(
        event,
        files,
        {
          msgtype: "file",
          title: file.name,
          size: file.size,
          ackid: "msg_" + messageLength++,
        },
        true
      );
    }
  };
  document.getElementById("textarea").onkeydown = function (e) {
    markConsultingTabActive("textarea_keydown");
    var ev = document.all ? window.event : e;
    if (ev.keyCode == 13 && !event.shiftKey) {
      event.preventDefault();
      sendTextArea();
    }
  };
  document.getElementById("textarea").onfocus = function () {
    markConsultingTabActive("textarea_focus");
  };
  if(utils.isUCBrowser){
    document.getElementById("pic-input").onchange = function (event) {
      markConsultingTabActive("select_picture");
      resolveSend(event);
    };
    document.getElementById("file-input").onchange = function (event) {
      markConsultingTabActive("select_file");
      resolveSend(event);
    };
    document.getElementById("video-btn").onchange = function (event) {
      markConsultingTabActive("select_video");
      resolveSend(event);
    };
  }else{
    document.getElementById("pic-input").oninput = function (event) {
      markConsultingTabActive("select_picture");
      resolveSend(event);
    };
    document.getElementById("file-input").oninput = function (event) {
      markConsultingTabActive("select_file");
      resolveSend(event);
    };
    document.getElementById("video-btn").oninput = function (event) {
      markConsultingTabActive("select_video");
      resolveSend(event);
    };
  }
  document.getElementById("drop-wrap").ondragover = function (event) {
    event.preventDefault();
    this.classList.add('drop-css');
    document.getElementsByClassName("drop-div-bg")[0].style.display = "block";
    document.getElementById('msg-wrapper').style.zIndex = -1;
    document.getElementsByClassName('footer')[0].style.zIndex = -1;
  };
  document.getElementById("drop-wrap").ondragleave = function (event) {
    event.preventDefault();
    this.classList.remove('drop-css');
    document.getElementsByClassName("drop-div-bg")[0].style.display = "none";
  };
  document.getElementById("drop-wrap").onmouseover = function (event) {
    document.getElementById('msg-wrapper').style.zIndex = '';
    document.getElementsByClassName("footer")[0].style.zIndex = '';
  };
  document.getElementById("drop-wrap").ondrop = function (event) {
    markConsultingTabActive("drop_file");
    event.preventDefault();
    this.classList.remove('drop-css');
    document.getElementsByClassName("drop-div-bg")[0].style.display = "none";
    document.getElementById('msg-wrapper').style.zIndex = '';
    document.getElementsByClassName("footer")[0].style.zIndex = '';
    const { files } = event.dataTransfer;
    let count = 0;
    for (const i in files) {
      if (typeof files[i] !== 'object') {
        continue;
      }
      count++;
      const file = files[i];

      if(utils.isImageFile(file.name)){
        // 图片限制10M - 提前检查
        if(file.size > 10 * 1024 * 1024){
          const sysMsg = {
            msgtype: "system",
            content: "图片的大小不能超过10M！",
            mid: "native_" + new Date().getTime(),
          };
          showMoreMessage(sysMsg, true);
          return;
        }

        resolveFileInput(event, files, {
          content: pic_uploading,
          msgtype: "image",
          ackid: "msg_" + messageLength++,
        });
      }else if(utils.isVideoFile(file.name)){
        // 处理视频发送
        if (file) {
          if(file.size > 25 * 1024 * 1024){
            const sysMsg = {
              msgtype: "system",
              content: "视频的大小不能超过25M！",
              mid: "native_" + new Date().getTime(),
            };
            showMoreMessage(sysMsg, true);
            return;
          }
          if(utils.isWindowsPC){
            handleVideoBg(file, event, files)
          }else{
            resolveFileInput(event, files, {
              msgtype: "video",
              content: '',
              thumb:'',
              width: 0,
              height: 0,
              duration: 0,
              size:'',
              ackid: "msg_" + messageLength++,
            });
          }
        }
      }else{
        // 文件限制25M - 提前检查
        if(file.size > 25 * 1024 * 1024){
          const sysMsg = {
            msgtype: "system",
            content: "文件的大小不能超过25M！",
            mid: "native_" + new Date().getTime(),
          };
          showMoreMessage(sysMsg, true);
          return;
        }

        resolveFileInput(
          event,
          files,
          {
            msgtype: "file",
            title: file.name,
            size: file.size,
            ackid: "msg_" + messageLength++,
          },
          true
        );
      }
      if (count === 5) {
        return;
      }
    }
  };
  document.addEventListener("paste", (event) => {
    markConsultingTabActive("paste");
    // https://www.jb51.net/article/80657.htm
    if (event.clipboardData || event.originalEvent) {
      //not for ie11  某些chrome版本使用的是event.originalEvent
      var clipboardData =
        event.clipboardData || event.originalEvent.clipboardData;
      if (clipboardData.items) {
        // for chrome
        const items = clipboardData.items;
        let blob;
        //在items里找粘贴的image,据上面分析,需要循环
        for (var i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            //getAsFile() 此方法只是living standard firefox ie11 并不支持
            blob = items[i].getAsFile();
          }
        }
        if (blob) {
          event.preventDefault();

          let file = event.clipboardData.files[0];

          // 粘贴图片限制10M - 提前检查
          if(file.size > 10 * 1024 * 1024){
            const sysMsg = {
              msgtype: "system",
              content: "图片的大小不能超过10M！",
              mid: "native_" + new Date().getTime(),
            };
            showMoreMessage(sysMsg, true);
            return;
          }

          if (window.FileReader) {
            const reader = new FileReader();
            reader.readAsDataURL(file); //必须加此项 否则onload无法执行
            reader.onload = (event) => {
              // event.target.result 即为图片的Base64编码字符串
              const imgData = event.target.result;
              utils.changePromoteDialog({
                content: `<img style="max-height:24rem; max-width:100%"  src=${imgData} />`,
                cb: function () {
                  resolveFileInput(
                    event,
                    { blob: blob },
                    {
                      content: pic_uploading,
                      msgtype: "image",
                      ackid: "msg_" + messageLength++,
                    },
                    false,
                    true
                  );
                },
              });
            };
          }else{ //不支持FileReader 的粘贴直接发出
            resolveFileInput(
              event,
              { blob: blob },
              {
                content: pic_uploading,
                msgtype: "image",
                ackid: "msg_" + messageLength++,
              },
              false,
              true
            );
          }
        }
      }
    }
  });

};

const messageReceived = (data) => {
  const messageMid = getReadMessageId(data);
  if (messageMid && (isMessageMidRemembered(messageMid) || getMessageElementByMid(messageMid))) {
    return;
  }
  const shouldStickToBottom = isChatPanelOpen() && isNearMessageBottom();
  const html = createMessageHtml(data, { createNode: true, readSource: "realtime" });
  const element = document.getElementById("msg-wrapper");
  element.appendChild(html);
  if (shouldStickToBottom) {
    utils.scrollDownEnd(undefined, 0);
    setNewMessageHintVisible(false);
    scheduleReadReceiptCheck(350);
  } else if (isChatPanelOpen() && data && data.uid != data.from_uid) {
    setNewMessageHintVisible(true);
  }
  startNotification(data);
};

const startNotification = (data) => {
  const iFrameState = shelltool.getifameState();
  if (loginData.config_data.notify_style == "auto_expand") {
    if (data.from_uid == data.uid) {
      return;
    }
    if (!iFrameState) {
      shelltool.postMessage({ type: "spread" });
      shelltool.setiFrameState(0);
    }
  } else if (!iFrameState) {
    shelltool.postMessage({ type: "redDot" });
  }
  if (!loginData.config_data.notify_is_voice) {
    return;
  }
  let visibile = document.visibilityState;
  if (visibile == undefined) {
    visibile = document.webkitHidden;
  }
  if (visibile == undefined) {
    visibile = document.hidden;
  }
  if (visibile == "visible" && iFrameState) {
    return;
  }
  const audio = document.getElementById("audio") || document.querySelector("audio");
  if (utils.IsIOS) {
    // 处理IOS上音频播放报错问题
    audio.onclick = function () {
      audio.play();
    };
    audio.click();
  } else {
    audio.onclick = function () {
      audio.play();
    };
  }
};
// 获取访客归属地信息
// 使用IPIP.net接口获取归属地 (支持CORS)
const getLocationFromIpip = () => {
  return new Promise((resolve) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => {
      controller.abort();
      resolve('');
    }, 2000);

    fetch('https://myip.ipip.net/json', {
      signal: controller.signal,
    })
        .then((res) => res.json())
        .then((data) => {
          clearTimeout(timeout);
          if (data && data.ret === 'ok' && data.data) {
            const ip = data.data.ip || '';
            const loc = data.data.location;

            if (loc && loc.length > 0) {
              // location: ["中国", "湖北", "武汉", "", "联通"]
              const country = loc[0] || '';
              const province = loc[1] || '';
              const city = loc[2] || '';
              const isp = loc[4] || '';

              // 国外直接显示国家
              if (country !== '中国') {
                resolve(country || ip);
                return;
              }

              // 直接拼接省市，不加"省"和"市"后缀
              const locationStr = province + (city && city !== province ? city : '');
              const addr = (locationStr + (isp ? ' ' + isp : '')).trim();
              resolve(addr || ip);
            } else {
              // 没有 location 信息，返回 IP
              resolve(ip);
            }
          } else {
            resolve('');
          }
        })
        .catch(() => {
          clearTimeout(timeout);
          resolve('');
        });
  });
};

// 使用又拍云接口获取归属地 (备用)
const getLocationFromUpyun = () => {
  return new Promise((resolve) => {
    fetch(`http://pubstatic.b0.upaiyun.com/?_upnode&r=${Date.now()}`)
        .then((res) => res.json())
        .then((data) => {
          const ip = data && data.remote_addr || '';
          const loc = data && data.remote_addr_location;
          if (loc) {
            // 国内：拼接省市，国外：显示国家
            if (loc.country === '中国') {
              // 直接拼接省市，不加"省"和"市"后缀
              const locationStr = loc.province + (loc.city && loc.city !== loc.province ? loc.city : '');
              const isp = loc.isp || '';
              const location = (locationStr + (isp ? ' ' + isp : '')).trim();
              resolve(location || ip);
            } else {
              resolve(loc.country || ip);
            }
          } else {
            // 没有 location 信息，返回 IP
            resolve(ip);
          }
        })
        .catch(() => resolve(''));
  });
};

// 获取访客归属地信息（带备用机制）
const getVisitorLocation = () => {
  return new Promise((resolve) => {
    const timeout = setTimeout(() => {
      resolve('');
    }, 2000);

    // 先尝试IPIP.net接口
    getLocationFromIpip().then((location) => {
      if (location) {
        clearTimeout(timeout);
        resolve(location);
        return; // IPIP成功，不调用备用接口
      }
      // IPIP失败，尝试又拍云备用接口
      getLocationFromUpyun().then((fallbackLocation) => {
        clearTimeout(timeout);
        resolve(fallbackLocation);
      });
    });
  });
};


const resolveLogin = (cb, failCb) => {
  if (window._ZHINI_CACHED_TOKEN && window._ZHINI_CACHED_CONFIG_DATA) {
    loginData.token = window._ZHINI_CACHED_TOKEN;
    window._ZHINI_CONFIG_DATA = window._ZHINI_CACHED_CONFIG_DATA;
    loginData.config_data = handleOrginalData(window._ZHINI_CONFIG_DATA);
    loginData.kefu_name_from = loginData.config_data[utils.IsPcMode ? "kefu_name" : "mobile_kefu_name"];
    cb();
    return;
  }

  delete urlParams.t;
  urlParams.version = "0.1.3";
  urlParams.adddomain = true;

  // 【关键】优先使用 SDK 传递的 client_id（用户配置的或系统生成的）
  let latestClientId = window._ZHINI_INIT_CLIENT_ID;

  // 如果 SDK 没有传递，则从 localStorage 获取
  if (!latestClientId) {
    latestClientId = localStorage.getItem('zhini_init_client_id_'+ urlParams.channel_id) ||
                     localStorage.getItem('zhini_client_id_'+ urlParams.channel_id);
  }

  if (latestClientId) {
    urlParams.client_id = latestClientId;
  }
  applyInitUserParams(urlParams);

  const MAX_NEWLOGIN_RETRY_COUNT = 3;
  const NEWLOGIN_RETRY_DELAY = 2000;
  const showNewloginNetworkError = () => {
    const sysMsg = {
      msgtype: "system",
      content: "网络异常连接已断开，请刷新页面重连！",
      mid: "native_" + new Date().getTime(),
    };
    showMoreMessage(sysMsg, true);
  };
  const isNetworkRetryableError = (error, status) => {
    if (!window.navigator.onLine) {
      return true;
    }
    if (status === 0) {
      return true;
    }
    if (!error) {
      return true;
    }
    if (typeof error === "string") {
      return error.trim() === "";
    }
    return false;
  };
  const sendNewloginRequest = (retryCount) => {
    ajaxUtils.httpRequest({
      url: '/wykf/api/v1/enterprise/webplugin/newlogin?version=' + encodeURIComponent(urlParams.version),
      type: "POST",
      contentType: "application/json; charset=UTF-8",
      data: buildNewloginRequestData(),
      success:  (result) => {
        if (result.sta !== 0) {
          if (result.errcode === 10003) {
            window._ZHINI_CACHED_TOKEN = null;
            window._ZHINI_CACHED_CONFIG_DATA = null;
          }
          failCb && failCb(result);
          return;
        }

        const data = result.data;
        loginData.token = data.token;
        syncLastReportedReadMid(data);

        window._ZHINI_CACHED_TOKEN = data.token;
        if (data.config_data) {
          window._ZHINI_CACHED_CONFIG_DATA = data.config_data;
        }

        if (data.config_data) {
            window._ZHINI_CONFIG_DATA = data.config_data;
        }

        loginData.config_data = handleOrginalData(data.config_data);

        if (data.config_data) {
            initStyles();
        }

        loginData.kefu_name_from =
            loginData.config_data[
                utils.IsPcMode ? "kefu_name" : "mobile_kefu_name"
                ];
        document.getElementById("profile").innerHTML = utils.replaceAll(
            loginData.config_data.customized_info,
            "<p></p>",
            "<p><br/></p>"
        );
        shelltool.postMessage(
            { type: "showBtn", data: window._ZHINI_CONFIG_DATA },
            100
        );
        window.requestHis = false
        cb();
      },
      error: (error, status) => {
        const zhiniAdNode = document.getElementsByClassName("agent-advertise")[0];
        if (zhiniAdNode) {
          zhiniAdNode.style.display = 'none';
        }
        if (isNetworkRetryableError(error, status) && retryCount < MAX_NEWLOGIN_RETRY_COUNT) {
          setTimeout(() => {
            sendNewloginRequest(retryCount + 1);
          }, NEWLOGIN_RETRY_DELAY);
          return;
        }
        if (isNetworkRetryableError(error, status)) {
          showNewloginNetworkError();
        }
        failCb && failCb(error);
      }
    });
  };

  getVisitorLocation().then((location) => {
    urlParams.location = location || '';
    sendNewloginRequest(0);
  }).catch((err) => {
    failCb && failCb(err);
  });
};

// 把新接口数据转化为原始数据
const handleOrginalData = function(configData){

    // 安全获取嵌套属性
    const safeGet = (obj, path, defaultVal) => {
        if (!obj) return defaultVal;
        return path.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : defaultVal), obj);
    };

    let pc = configData ? (configData.pc || {}) : {};
    let mobile = configData ? (configData.mobile || {}) : {};
    let notify = configData ? (configData.notify || {}) : {};

    let data = {
      button_color: safeGet(pc, 'menubar.button_style.color', '#4A90E2'),
      button_content: safeGet(pc, 'menubar.buttons', []),
      button_position: safeGet(pc, 'menubar.button_style.horizontal', 'right'),
      button_style: safeGet(pc, 'menubar.button_style.shape', 'round'),
      vertical: safeGet(pc, 'menubar.button_style.vertical', ''),

      customized_info: safeGet(pc, 'chatbox.window_config.right_sidebar_content', ''),
      title: safeGet(pc, 'chatbox.window_config.title', '在线客服'),
      form_color: safeGet(pc, 'chatbox.window_style.color', '#ffffff'),
      form_position: safeGet(pc, 'chatbox.window_style.horizontal', 'right'),
      form_style: pc.chatbox && pc.chatbox.type == 1 ? 'customized' : 'normal',
      head_img: safeGet(pc, 'chatbox.window_config.avatar', ''),
      kefu_name: safeGet(pc, 'chatbox.window_config.nickname', '客服'),
      show_enable_ad: safeGet(pc, 'chatbox.window_config.enable_ad', false),

      mobile_button_color: safeGet(mobile, 'menubar.button_style.color', '#4A90E2'),
      mobile_button_content: safeGet(mobile, 'menubar.buttons', []),
      mobile_button_position: safeGet(mobile, 'menubar.button_style.horizontal', 'right'),
      mobile_button_style: safeGet(mobile, 'menubar.button_style.shape', 'round'),
      mobile_vertical: safeGet(mobile, 'menubar.button_style.vertical', ''),

      mobile_form_color: safeGet(mobile, 'chatbox.window_style.color', '#ffffff'),
      mobile_form_style: mobile.chatbox && mobile.chatbox.type == 1 ? 'full_screen' : 'half_screen',
      mobile_head_img: safeGet(mobile, 'chatbox.window_config.avatar', ''),
      mobile_kefu_name: safeGet(mobile, 'chatbox.window_config.nickname', '客服'),
      mobile_title: safeGet(mobile, 'chatbox.window_config.title', '在线客服'),
      mobile_show_enable_ad: safeGet(mobile, 'chatbox.window_config.enable_ad', false),

      notify_is_voice: notify ? notify.open_voice : false,
      notify_style: notify ? notify.style : 'banner',
    }

    //兼容旧数据
    if(typeof(data.button_content) == 'string' || !data.button_content){
      data.button_content = [{
        type: 'chatbox',
        title: data.button_content || '客服在线，点击咨询',
        icon_source_type: 0,
        icon_img_url: '',
        status: 1,
        system_icon_type: 0,
      }]
    }

  if(typeof(data.mobile_button_content) == 'string' || !data.mobile_button_content){
    data.button_content = [{
      type: 'chatbox',
      title: data.button_content || '客服在线，点击咨询',
      icon_source_type: 0,
      icon_img_url: '',
      status: 1,
      system_icon_type: 0,
    }]
  }

    if(data.button_position == 'rightCenter'){
      data.button_position = 'right';
      data.vertical = '50%';
    }
    if(data.button_position == 'leftCenter'){
      data.button_position = 'left';
      data.vertical = '50%';
    }
    if(data.mobile_button_position == 'rightCenter'){
      data.mobile_button_position = 'right';
      data.mobile_vertical = '50%';
    }

    if(data.mobile_button_position == 'leftCenter'){
      data.mobile_button_position = 'left';
      data.mobile_vertical = '50%';
    }
    return data;
}
const initContents = () => {
  const config_data = loginData.config_data;
  const pcMode = utils.IsPcMode;
  const titleNode = document.getElementsByClassName("agent-info")[0];
  titleNode.innerHTML = config_data[pcMode ? "title" : "mobile_title"] || "";
  const headImgNode = document.getElementsByClassName("agent-avatar")[0];
  const headImgSrc = config_data[pcMode ? "head_img" : "mobile_head_img"];
  const headAdShow = config_data[pcMode ? "show_enable_ad" : "mobile_show_enable_ad"];
  if (headImgSrc) {
    headImgNode.src = headImgSrc;
    headImgNode.style.display = "block";
  } else {
    titleNode.style.marginLeft = "16px";
  }
  const zhiniAdNode = document.getElementsByClassName("agent-advertise")[0];
  if(Number(headAdShow) === 0){
    if(pcMode){
      titleNode.style.height = '60px';
      titleNode.style.lineHeight = '60px';
      zhiniAdNode.style.display = 'none';
    }else{
      titleNode.style.height = '60px';
      titleNode.style.lineHeight = '60px';
      zhiniAdNode.style.display = 'none';
    }

  }
};

const initStyles = () => {
  const config_data = loginData.config_data;

  if (!config_data) {
    return;
  }


  // 【重要】移除旧的样式标签，避免重复
  const oldStyle = document.getElementById('zhini-dynamic-styles');
  if (oldStyle) {
    oldStyle.remove();
  }

  const styleNode = document.createElement("style");
  styleNode.id = 'zhini-dynamic-styles';
  styleNode.setAttribute("type", "text/css");
  const formColor =
    config_data[utils.IsPcMode ? "form_color" : "mobile_form_color"];


  // 检查颜色是否有效（不是白色默认值才覆盖样式）
  const isValidColor = formColor && formColor !== '#ffffff' && formColor !== '#fff' && formColor !== 'ffffff';

  // 构建样式内容
  let styleContent = '';
  if (isValidColor) {
    styleContent = `
    .chat-header {
      background: ${formColor} !important;
    }
    .body-left .footer .text-holder #send-btn {
      background: ${formColor} !important;
    }
    .message-item.message-right .message-text {
      background: ${formColor} !important;
      color: #fff !important;
    }`;
  }

  if (config_data.form_style == "normal" || !utils.IsPcMode) {
    styleContent += '.body-right{display: none !important;}.chat-body{padding-right: 0 !important;}';
  };

  if (styleNode.styleSheet) {
    styleNode.styleSheet.cssText = styleContent;
  } else {
    styleNode.appendChild(document.createTextNode(styleContent));
  }
  document.head.appendChild(styleNode);

  // 样式注入完成后，通知外层插件
  window.parent.postMessage({ type: 'zhini-styles-ready' }, '*');
};

// 暴露触发函数给 shelltool.js 调用
window.triggerInitStyles = () => {
  // 重新从 window._ZHINI_CONFIG_DATA 读取配置（确保使用最新的）
  if (window._ZHINI_CONFIG_DATA) {
    loginData.config_data = handleOrginalData(window._ZHINI_CONFIG_DATA);
  }

  initStyles();
};

let messageLength = 0;
let lastMid = "";
const loginData = {};
const urlParams = utils.getAllparams();
// 添加防重复标志
let isContentStartProcessing = false;
let hasContentStarted = false;
let activeTabReconnectRetryTimer = null;

const reconnectActiveTabWithToken = (params) => {
  const reconnectToken = params && (params.token || loginData.token || window._ZHINI_CACHED_TOKEN);
  if (!reconnectToken) {
    return false;
  }
  loginData.token = reconnectToken;
  const reconnectParams = Object.assign({}, params);
  if (!isChatPanelOpen()) {
    // 隐藏聊天窗口时只恢复 WebSocket，不让 onopen 触发 message 历史接口。
    delete reconnectParams.type;
  }
  // 多 Tab 恢复只复用现有 token 重建 WebSocket，不重新执行登录流程。
  wsUtils.startProcess("init", {
    messageReceived,
    token: reconnectToken,
    params: reconnectParams,
  });
  return true;
};

const startProcess = (params) => {
  if (params && params.activeTabReconnect) {
    if (params.token) {
      loginData.token = params.token;
    }
    if (isContentStartProcessing) {
      if (activeTabReconnectRetryTimer) {
        return;
      }
      activeTabReconnectRetryTimer = setTimeout(() => {
        activeTabReconnectRetryTimer = null;
        startProcess(params);
      }, 500);
      return;
    }
    if (isChatPanelOpen() && wsUtils.isWsAvailable()) {
      requestMessageList(undefined, undefined, { showRecoveryMessage: false });
      return;
    }
    reconnectActiveTabWithToken(params);
    return;
  }

  // 防重复检查
  if (isContentStartProcessing) {
    if (params && params.errcode === 10003) {
      setTimeout(() => {
        startProcess(params);
      }, 500);
    }
    return;
  }

  if (hasContentStarted && !params) {
    return;
  }

  // 设置处理标志
  isContentStartProcessing = true;

  if (params && params.errcode === 10003) {
    wsUtils.startProcess("closeWsPingEvent", params);
    // 重置标志，允许重新初始化
    hasContentStarted = false;
    // 【重要】清除内存缓存，让 resolveLogin 重新调用 newlogin
    window._ZHINI_CACHED_TOKEN = null;
    window._ZHINI_CACHED_CONFIG_DATA = null;
  }

  const finishStartProcess = (started) => {
    hasContentStarted = !!started;
    isContentStartProcessing = false;
  };

  resolveLogin(() => {
    wsUtils.startProcess("init", {
      messageReceived,
      token: loginData.token,
      params,
    });
    // initStyles() 不再在这里调用，改为由 shelltool.js 收到 init 消息后触发
    initContents();
    initEmojiFunction();
    initActions();
    initReadReceiptWatcher();
    finishStartProcess(true);
  }, () => {
    finishStartProcess(false);
  });
};
export default {
  startProcess: startProcess,
  showMoreMessage: showMoreMessage,
  requestMessageList: requestMessageList,
};



// WEBPACK FOOTER //
// ./src/js/content.js